import type React from 'react';
import { cn } from '@/lib/utils';

export function CenteredContentLayout({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        '[--content-width:60rem]',
        'grid w-full min-w-0 grid-cols-1',
        'lg:grid-cols-[minmax(0,1fr)_minmax(0,var(--content-width))_minmax(0,1fr)]',
        className
      )}
    >
      {children}
    </div>
  );
}

export function CenteredContent({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'col-start-1 row-start-2 w-full min-w-0 max-w-[var(--content-width)] mx-auto px-8',
        'lg:col-start-2 lg:mx-0 lg:max-w-none',
        className
      )}
    >
      {children}
    </div>
  );
}

export function Header({
  children,
  className,
  rightGutter = false,
}: {
  children: React.ReactNode;
  className?: string;
  rightGutter?: boolean;
}) {
  return (
    <>
      <div
        className={cn(
          'sticky top-0 z-10 bg-background pt-8 pb-4 px-8 shadow-[0_4px_2px_-2px_rgba(0,0,0,0.06)]',
          'col-start-1 row-start-1 mb-8 w-full min-w-0 max-w-[60rem] mx-auto',
          'lg:mb-12 lg:mx-0 lg:max-w-none',
          rightGutter ? 'lg:col-end-3' : 'lg:col-end-4',
          className
        )}
      >
        {children}
      </div>
      {rightGutter && (
        <div
          aria-hidden
          className={cn(
            'sticky top-0 z-10 hidden bg-background pt-8 pb-4 px-8 shadow-[0_4px_2px_-2px_rgba(0,0,0,0.06)]',
            'lg:col-start-3 lg:row-start-1 lg:mb-12 lg:block lg:w-full'
          )}
        />
      )}
    </>
  );
}
